<script lang="ts">
    import { push } from "svelte-spa-router";
    import { userStore } from "../../auth/userStore";
    import IconButton from "../../components/buttons/IconButton.svelte";
    import BurgerIcon from "../../components/icons/BurgerIcon.svelte";
    import LogoutIcon from "../../components/icons/LogoutIcon.svelte";
    import ProjectOverviewIcon from "../../components/icons/ProjectOverviewIcon.svelte";
    import DropdownMenu from "../../components/menu/dropdown/DropdownMenu.svelte";
    import DropdownMenuItem from "../../components/menu/dropdown/DropdownMenuItem.svelte";

    let showMenu = false;
</script>

<div class="Menu" on:click|stopPropagation={() => {}}>
    <IconButton
        icon={BurgerIcon}
        title="Menu"
        color="#333"
        onClick={() => {
            showMenu = !showMenu;
        }}
    />
    {#if showMenu}
        <DropdownMenu
            closeCallback={() => {
                showMenu = false;
            }}
        >
            <slot></slot>
            <DropdownMenuItem
                title="Project overview"
                icon={ProjectOverviewIcon}
                onClick={() => {
                    showMenu = false;
                    push("/");
                }}
            />
            <DropdownMenuItem
                title="Logout"
                icon={LogoutIcon}
                onClick={() => {
                    showMenu = false;
                    userStore.logout();
                }}
            />
        </DropdownMenu>
    {/if}
</div>

<style type="text/scss">
    .Menu {
        position: fixed;
        top: 10px;
        left: 10px;
        z-index: 1;
    }
</style>
